import React from "react";
import PropTypes from "prop-types";
import { MenuItem, Select } from "@material-ui/core";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const LangSelect = styled(Select)`
  margin: 0 8px;
  color: inherit;
  font-size: 14px;

  .MuiSelect-icon {
    color: inherit;
  }
`;

const LanguageSwitcher = ({ className }) => {
  const { i18n, t } = useTranslation();
  const value =
    i18n.language && i18n.language.toLowerCase().startsWith("en")
      ? "en"
      : "pt-BR";

  const handleChange = event => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <LangSelect
      className={className}
      value={value}
      onChange={handleChange}
      disableUnderline
      inputProps={{ "aria-label": t("shell.language") }}
    >
      <MenuItem value="pt-BR">PT</MenuItem>
      <MenuItem value="en">EN</MenuItem>
    </LangSelect>
  );
};

LanguageSwitcher.propTypes = {
  className: PropTypes.string
};

LanguageSwitcher.defaultProps = {
  className: undefined
};

export default LanguageSwitcher;
